<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
        tooltip-placement="right"
        uib-tooltip="Cancel"
      />
    </a>

    <div class="action-icon">
      <a
        class="btn btn-list-function"
        @click="showForm"
      >
        <i
          v-tooltip.bottom.hover="{text:$t('GROUP_ACTIONS_EDIT'), transition: 0}"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <div class="action-icon m-t-2">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showInvites"
      >
        <i
          v-tooltip.bottom.hover="{text:$t('MANAGE_USER_INVITES'), transition: 0}"
          class="fa fa-user-plus"
          aria-hidden="true"
        />
        </v-tooltip>
        <span
          v-t="'MANAGE_USER_INVITES'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <div class="action-icon">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="confirmDeleteModal"
      >
        <i
          v-tooltip.bottom.hover="{text:$t('GROUP_ACTIONS_DELETE'), transition: 0}"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </a>
    </div>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'UserGroupActions',
  props:{
    group: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    collapseActions() {
      this.$emit('collapse-actions', this.group.id);
    },
    showForm() {
      this.$emit('show-edit', this.group.id);
    },
    showInvites() {
      if (!this.disabled) {
        this.$emit('show-invites', this.group.id);
      }
    },
    confirmDeleteModal() {
      if (!this.disabled) {
        this.$emit('confirm-delete-group', this.group);
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>

<style lang="scss">
form.user-group {
  .multi-select-lg {
    width: 100%;
  }

  .v-select .vs__selected {
    height: 32px;
    padding: 8px 8px 7px 10px;
    border-bottom: 1px solid transparent;
  }
}
</style>